import { render, staticRenderFns } from "./PageTab.vue?vue&type=template&id=a7e842a0&scoped=true&"
import script from "./PageTab.vue?vue&type=script&lang=js&"
export * from "./PageTab.vue?vue&type=script&lang=js&"
import style0 from "./PageTab.vue?vue&type=style&index=0&id=a7e842a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e842a0",
  null
  
)

export default component.exports